import React from 'react';

import {StringIDFolder} from 'constants/FolderConstants';
import {NavStoreSource} from 'constants/SourceConstants';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import SourceSidepanelItem from './SourceSidepanelItem';

export interface SourceListProps {
  className?: string;
  finderId: string;
  openResult: (rootFolder: StringIDFolder) => void;
  sources: Array<NavStoreSource>;
  areSourcesLoading: boolean;
}

export default function SourceList(props: SourceListProps): JSX.Element {
  if (props.areSourcesLoading) {
    return (
      <div className={props.className}>
        <CenteredHorizontalThrobber />
      </div>
    );
  } else if (props.sources.length === 0) {
    return (
      <div className={props.className}>
        <span className="sidepanel-fadedMessage">None found.</span>
      </div>
    );
  }
  return (
    <div className={props.className}>
      {props.sources.map((source, i) => (
        <SourceSidepanelItem
          finderId={props.finderId}
          key={i}
          openResult={props.openResult}
          showCreator={false}
          showOwner={true}
          showStar={false}
          source={source}
          isChild={false}
        />
      ))}
    </div>
  );
}
